import { app } from '../app.module'
app
  /**
   * trustUrl URLをtrustAsResourceUrlに変換
   * @param  {String} url リンク
   * @return {String} trustAsResourceUrlのリンク
   */
  .filter('trustUrl', ($sce) => {
    return function (url) {
      return $sce.trustAsResourceUrl(url)
    }
  })
